// @flow
import React from 'react';
import { colors } from 'bench-style-constants';
import { Icon, TextBlock } from 'bench-internal-theme';
import styled from 'styled-components';
import TextColumn from '../TextColumn';
import IconColumn from '../IconColumn';
import { useMediaQuery } from 'react-responsive';
import breakpoints from '../../constants/breakpoints';

const TableHeaderLayout = styled(TextBlock).attrs(() => ({
  color: colors.smoke,
  styleType: 'small',
  uppercase: true,
}))`
  // Ensures there's a "bottom border", but doesn't change the height
  align-items: center;
  background-color: ${colors.pearl};
  border-top: 1px solid ${colors.silt};
  box-shadow: 0 1px 0 ${colors.silt};
  height: 33px;
  display: grid;
  grid-column-gap: 16px;
  margin: 0 32px;
  padding: 8px;
  grid-template-columns: ${({ isLd, isHd, isTablet }) => {
    if (isHd) {
      return '3fr 0.2fr 1fr 1fr 1fr 0.5fr 0.8fr 0.8fr 0.2fr 0.2fr';
    }
    if (isLd) {
      return `3fr 0.2fr 1fr 1fr 1fr 0.2fr 0.2fr`;
    }
    if (isTablet) {
      return `3fr 2fr 1fr 0.2fr 0.2fr`;
    }
    return `3fr 0.2fr 0.2fr`;
  }};
`;

const AddonsTabHeader = () => {
  const isHd = useMediaQuery({ minWidth: breakpoints.hd });
  const isLd = useMediaQuery({ minWidth: breakpoints.ld });
  const isTablet = useMediaQuery({ minWidth: breakpoints.tablet });

  return (
    <TableHeaderLayout isLd={isLd} isHd={isHd} isTablet={isTablet}>
      <TextColumn align="left" key="name">
        Name
      </TextColumn>
      {isTablet && (
        <>
          <IconColumn key="notebook" title="Notes">
            <Icon title="Notes" color={colors.clay} icon="notebook" size="small" />
          </IconColumn>
          <TextColumn align="left" key="account">
            Account Type
          </TextColumn>
        </>
      )}
      {isLd && (
        <>
          <TextColumn align="left" key="dateActive">
            Date Active
          </TextColumn>
          <TextColumn align="left" key="dateInactive">
            Date Inactive
          </TextColumn>
        </>
      )}
      {isHd && (
        <>
          <TextColumn align="left" key="volume">
            Volume
          </TextColumn>
          <TextColumn align="left" key="collection">
            Collection
          </TextColumn>
          <TextColumn align="left" key="optimization">
            Optimization
          </TextColumn>
        </>
      )}
      <IconColumn key="pencil" title="Edit">
        <Icon color={colors.clay} icon="pencil" size="small" />
      </IconColumn>
      <IconColumn key="trash" title="Delete">
        <Icon color={colors.clay} icon="close" size="small" />
      </IconColumn>
    </TableHeaderLayout>
  );
};

export default AddonsTabHeader;
